import { LineItemData } from '@api/types';
import { TextCodes } from '@api/types/translation/TextCodes';
import { useCart } from '@hooks/cart/cart.hooks';
import ChatBubbleOutline from '@mui/icons-material/ChatBubbleOutline';
import { Box, BoxProps, InputAdornment, TextField } from '@mui/material';
import { colors } from '@themes/colors';
import { t } from '@translations';
import { ChangeEvent, useEffect, useState } from 'react';
import { useDebounce } from 'usehooks-ts';

export type LineItemNoteProps = Pick<BoxProps, 'p'> & {
  lineItem?: LineItemData;
  isEditable?: boolean;
};

export const LineItemNote = ({ isEditable, lineItem = {}, p = 0 }: LineItemNoteProps) => {
  const note = lineItem?.note === null ? '' : lineItem.note;
  const { changeItemNote } = useCart();
  const [localText, setLocalText] = useState<string>(note || '');
  const debouncedValue = useDebounce<string>(localText, 1000);
  const onChange = (e: ChangeEvent<HTMLInputElement>) => setLocalText(e.target.value);
  useEffect(() => {
    if (isEditable && debouncedValue !== note) {
      changeItemNote(lineItem?.code, debouncedValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedValue]);
  return isEditable ? (
    <Box p={p}>
      <TextField
        InputProps={{
          startAdornment: (
            <InputAdornment position='start'>
              <ChatBubbleOutline />
            </InputAdornment>
          ),
        }}
        placeholder={t(TextCodes.Product.Cart.ProductItemCartNote)}
        value={localText}
        onChange={onChange}
        fullWidth
      />
    </Box>
  ) : lineItem.note ? (
    <Box
      sx={{
        fontStyle: 'italic',
        color: colors.text.secondary,
      }}
      p={p}
    >
      <Box sx={{ fontWeight: 'bold', marginRight: 1 }} component='span'>
        {t(TextCodes.Product.Cart.ProductItemCartNote)}:
      </Box>
      {lineItem.note}
    </Box>
  ) : null;
};
